import objectFitImages from 'object-fit-images'

export default class {
  constructor () {
    objectFitImages('img.img-cover')
    objectFitImages('img.img-contain')
  }
}
